"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isImageSizeAllowed = void 0;
var imageUploadSizeLimit = parseFloat("16000000");
var isImageSizeAllowed = exports.isImageSizeAllowed = function isImageSizeAllowed(imageFile) {
  return imageFile.size <= imageUploadSizeLimit;
};